import { classnames } from 'Utils/classnames/classnames.utils';
import { useRouter } from 'next/router';
import React from 'react';
import { windowWrapper } from '@clubmed/utils';
import { generateProductLink } from 'Components/widgets/product/Product.utils';
import DynamicLinkUtil from 'Components/frameworks/dynamic-link/DynamicLinkUtil';
import type { ProductPriceInfoProps } from 'Components/widgets/product-price-info/ProductPriceInfo';
import 'Components/widgets/product-price-info/ProductPriceInfo';
import { ProductHeader } from 'Components/widgets/product/product-header/ProductHeader';
import { ProductFlag } from 'Components/widgets/product/product-flag/ProductFlag';
type Props = {
  className?: string;
  header: {
    heading: {
      title: string;
      subtitle?: string;
    };
  };
  offer?: Offer;
  price: Record<string, any>;
  priceInfo: ProductPriceInfoProps;
  url: string;
};
export const ProductCondensed = ({ className, header, offer, price, priceInfo, url }: Props) => {
  const router = useRouter();

  const goOnResort = () => {
    const newHistoryState = new DynamicLinkUtil(
      windowWrapper.getLocation(),
      url ? generateProductLink(url, offer) : '',
    );
    router.push(newHistoryState.toString());
  };

  return (
    <article className={classnames('flex flex-col', className)}>
      <ProductHeader {...header} isLinkDisabled />
      <ProductFlag
        isLinkDisabled
        onClick={goOnResort}
        price={price}
        priceInfo={priceInfo}
        theme="thumbnail"
      />
    </article>
  );
};
